<template>
    <div>
        正在登录统一门户
    </div>
</template>
<script>
/* eslint-disable */ 
import * as dd from "dingtalk-jsapi";
export default {
    data(){
        return {
            corpId: ''
        }
    },
    watch: {
        '$route':{
            handler() {
                this.dindin()
            },
            deep: true
        }
    },
    created(){
        this.initData()
    },
    mounted() {
        // this.dindin()
    },
    methods:{
        dindin(data) {
            if (dd.env.platform !== "notInDingTalk") {
                dd.ready(function() {
                    dd.runtime.permission.requestAuthCode({
                        corpId: data,
                        onSuccess: function (info) {
                            window.location.href = `${window.location.origin}/sso/dingDing/autoLoginByCode?fromType=mobile&code=${info.code}`;
                        }, 
                        onFail: function(err){
                            alert(err.errorMessage)
                        }
                        });
                });
            }
        },
        initData() {
            this.$request.post('/sso/backgroundSet/findUsedBgSet').then(res => {
                const { code, data } = res.data
                const settingLogin = res.data.extra
                if (code === 'OK') {
                    this.corpId = settingLogin.dingding.corpId
                    this.dindin(this.corpId)
                    console.log(settingLogin.sysLogoTitle.sys_portal_title)
                }
            }).catch((err) => {
                console.log(err)
            })
        }
    }
}
</script>